export enum SharedQueries {
	// Brands
	GET_BRANDS = `
    query Brands {
        brands(order: { name: ASC }) {
            nodes {
                name
                id
            }
        }
    }        
    `,

	// Categories
	GET_CATEGORIES = `
    query Categories($where: CategoryFilterInput, $first: Int, $after: String) {
        categories(
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// Style Groups
	GET_STYLE_GROUPS = `
    query StyleGroups($where: StyleGroupFilterInput, $first: Int, $after: String) {
        styleGroups(
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// Style Descriptions
	GET_STYLE_DESCRIPTIONS = `
    query StyleDescriptions($where: StyleDescriptionFilterInput, $first: Int, $after: String) {
        styleDescriptions(
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	//COLLECTIONS
	GET_COLLECTIONS = `
    query Collections($where: CollectionFilterInput, $first: Int, $after: String)  {
        collections(    
            where: $where,
            first: $first,
            after: $after,
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// GENDERS
	GET_GENDERS = `
    query Genders($where: GenderFilterInput, $first: Int, $after: String) {
        genders(
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// PURPOSES
	GET_PURPOSES = `
    query Purposes($where: PurposeFilterInput, $first: Int, $after: String) {  
        purposes(  
         where: $where,
            first: $first,
            after: $after,
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// TEAMS
	GET_TEAMS = `
    query Teams( $where: TeamFilterInput, $first: Int, $after: String) {
        teams(  
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            totalCount
        }
    }
    `,

	// Colors
	GET_COLORS = `
    query Colors( $where: ColorFilterInput, $first: Int, $after: String) {
        colors(
            where: $where,
            first: $first,
            after: $after,
            order: { name: ASC }
        ) {
            nodes {
                id
                code
                finalColorName
            }
            totalCount
        }
    }
    `,

	GET_COMPANIES = `
    query CompaniesByUserProfile($search: String, $first: Int, $after: String) {
        companiesByUserProfile(
            first: $first
            after: $after
            where: { name: { contains: $search }, active: { eq: true }, cancelled: { eq: false } }
        ) {
            totalCount
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,

	GET_COMPANY_BY_ID = `
    query CompanyById($id: Int!) {
        companies(
            first: 1
            where: { id: { eq: $id }, active: { eq: true }, cancelled: { eq: false } }
        ) {
            nodes {
                id
                name
            }
        }
    }
    `
}
